import React from "react";
import "../../styles/About.css";

function About() {
    return (
        <div className="about-container">
            <h2>About Me</h2>
            <p>I'm a passionate photographer specializing in street, portrait, city, and landscape photography.</p>
            <p>Contact me at: zidiyaocanada@outlook.com or yaoz25@mcmaster.ca</p>
            <p> More features will be added later</p>

        </div>
    );
}

export default About;